module.exports = __webpack_public_path__ + "static/media/AjusteEstoque1.8a3cb4bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancAjusteEstoque/AjusteEstoque1.png
// module id = 2048
// module chunks = 0